import { createFileRoute, redirect } from '@tanstack/react-router';
import { getToken } from '@/utils/authToken.ts';
import GuestLayout from '@/layouts/GuestLayout.tsx';

export const Route = createFileRoute('/_guest')({
  beforeLoad: () => {
    const token = getToken();
    if (token) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: GuestLayout,
});
